import React, { useContext } from "react";
import {
    TimelineFrameContentLabelledWrapper,
    timelineFrameContentLabels
} from "../../../TimelineFrameContentLabelledWrapper";
import TimelineFrameContentDateTime from "./default/TimelineFrameContentDateTime";
import TimelineFrameContentEventSpecificInfo from "./default/TimelineFrameContentEventSpecificInfo";
import {TimelineFrameDataContext} from "../../../../TimelineFramePage";
import {isEmpty} from "lodash";
import {TYPE_FIMLAB} from "../../../../../../definitions/TimelineItems";
import {TimelineFrameContentFimlabAppointment} from "./fimlab/TimelineFrameContentFimlabAppointment";
import {TimelineFrameContentFimlabSpecific} from "./fimlab/TimelineFrameContentFimlabSpecific";


export const TimelineFrameContentAppointment = () => {

    const { data } = useContext(TimelineFrameDataContext);

    if (!data.type || isEmpty(data.type)){
        return null;
    }

    if (data.type === TYPE_FIMLAB) {
        return (
            <TimelineFrameContentLabelledWrapper label={timelineFrameContentLabels.DATE_FIMLAB}
                                                 withHorizontalRule={true}>
                <TimelineFrameContentFimlabAppointment />
                {/*<TimelineFrameContentFimlabSpecific data={data} />*/}
            </TimelineFrameContentLabelledWrapper>
        )
    }


    return (
        <TimelineFrameContentLabelledWrapper label={timelineFrameContentLabels.DATE}
                                             withHorizontalRule={true}>
            <TimelineFrameContentDateTime/>
            <TimelineFrameContentEventSpecificInfo/>
        </TimelineFrameContentLabelledWrapper>
    );
}